<template>
  <div>
    <v-dialog
      max-width="500"
      persistent
      scrollable
      v-if="isOpenDialer"
      :value="isOpenDialer"
      @click:outside="toggleDialog"
    >
      <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
        <v-card>
          <v-progress-linear v-if="isLoading" indeterminate color="primary" rounded height="6"></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text"> Marcar </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text class="mb-5" style="max-height: 350px">
              <v-form ref="dialerForm">
                <v-row>
                  <!-- Colas -->
                  <v-col cols="12" class="py-0">
                    <ValidationProvider name="Cola" rules="required" v-slot="{ errors }">
                      <v-select
                        v-model="payload.queue"
                        :items="queueList"
                        :error-messages="errors"
                        :loading="isLoadingQueues"
                        item-text="name"
                        item-value="number"
                        prepend-inner-icon="mdi-database"
                        label="Cola"
                        filled
                        rounded
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                  <!-- Numero -->
                  <v-col cols="12" class="py-0">
                    <ValidationProvider name="número" rules="required" v-slot="{ errors }">
                      <v-text-field
                        v-model="payload.call_number"
                        :error-messages="errors"
                        label="Número a marcar"
                        prepend-inner-icon="mdi-phone"
                        @input="formatCallNumber"
                        filled
                        rounded
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <!--                 
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="payload.type"
                    :error-messages="errors"
                    label="Tipo"
                    prepend-inner-icon="mdi-bookshelf"
                    filled
                    rounded
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="payload.variable_1"
                    :error-messages="errors"
                    label="Variable 1"
                    prepend-inner-icon="mdi-compare-vertical"
                    filled
                    rounded
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="payload.variable_2"
                    :error-messages="errors"
                    label="Variable 2"
                    prepend-inner-icon="mdi-compare-vertical"
                    filled
                    rounded
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="payload.variable_3"
                    :error-messages="errors"
                    label="Variable 3"
                    prepend-inner-icon="mdi-compare-vertical"
                    filled
                    rounded
                  ></v-text-field>
                </v-col> -->
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2 white">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="toggleDialog">
                Cancelar
              </v-btn>
            </v-hover>
            <v-btn-toggle v-if="hasRTC">
              <v-btn small :loading="isLoading" :disabled="isLoading" color="success" @click="handleSubmit(submitForm)">
                <v-icon color="white">mdi-phone</v-icon>
              </v-btn>

              <v-btn
                small
                :loading="isLoading"
                :disabled="isLoading"
                color="success"
                @click="handleSubmit(() => submitForm(true))"
              >
                <v-icon color="white">mdi-video</v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-btn
              v-else
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="handleSubmit(submitForm)"
            >
              Llamar
            </v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>

    <call-banner
      :showCallBanner="showCallBanner"
      :callStatusText="callStatusText"
      :hasIncomingCall="hasIncomingCall"
      :displayName="displayName"
      :phoneNumber="numberToCall"
      :hasInProgressCall="showCallCounter"
      :counterStatus="counterStatus"
      :isMuted="callButtons.mute"
      :isActiveHold="callSession && this.callButtons.hold"
      :isVideoCall="isVideoCall"
      @call:toggleMute="sipToggleMute"
      @call:toggleHold="sipToggleHoldResume"
      @call:transfer="sipTransfer"
      @call:answer="handleAnswerSipCal"
      @call:hangup="sipHangUp"
      @call:dtmf="sipSendDTMF"
    ></call-banner>
  </div>
</template>

<script>
import vuescroll from "vuescroll";
import axios from "axios";
import { PbxHttpClient } from "@/services/httpclient";
import CallBanner from "./CallBanner.vue";
import * as JsSIP from "jssip";
// import { getRealmUrl } from "../../Utils/getRealmUrl";
import {
  startRingTone,
  stopRingTone,
  startRingbackTone,
  stopRingbackTone,
  checkNotificationPermission,
} from "../../Utils/SIPHelpers";

const addLog = (message) => {
  console.log(message);
};

export default {
  components: { vuescroll, CallBanner },

  data() {
    return {
      isLoading: false,
      isLoadingQueues: true,
      itLoadSipAPI: false,
      payload: {
        call_number: "",
        queue: null,
        type: "0",
        variable_1: "",
        variable_2: "",
        variable_3: "",
      },
      queueList: [],
      dataFromCall: {},
      // SIPml5
      oSipStack: null,
      oSipSessionCall: null,
      oSipSessionTransferCall: null,
      oSipSessionRegister: null,
      oNotifICall: null,
      oConfigCall: {},
      callStatusText: "Llamando",
      numberToCall: "",
      showCallBanner: false,
      showCallCounter: false,
      counterStatus: "play",
      DTMF: "",
      hasIncomingCall: false,
      callButtons: {
        mute: false,
        hold: false,
      },
      videoLocal: null,
      videoRemote: null,
      isVideoCall: false,
      displayName: "",
      incomingNumberCall: "",
      callSession: null,
      selectedAudioInput: null,
      audioDevices: [],
    };
  },

  computed: {
    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },
    isOpenDialer() {
      return this.$store.getters["dialer/GET_IS_OPEN"];
    },
    hasRTC() {
      return !!this.ProfileInfo.web_rtc;
    },
    AutoAnswerCalls() {
      return !!this.ProfileInfo.web_rtc?.auto_answer;
    },
    isConnectedToSIP() {
      return this.$store.getters["dialer/GET_IS_CONNECTED"];
    },
    startCall() {
      return this.$store.getters["dialer/GET_START_DIRECT_CALL"];
    },
    IsFromCampaignRegister() {
      return this.$store.getters["dialer/GET_IS_FOR_CAMPAIGNS_REGISTER"];
    },
  },

  created() {
    this.getQueues();

    this.payload.call_number = this.$store.getters["dialer/GET_NUMBER_TO_CALLL"] || "";
    this.payload.queue = this.$store.getters["dialer/GET_QUEUE_TO_CALL"] || null;
  },

  mounted() {
    const shouldConnect = this.isConnectedToSIP || this.AutoAnswerCalls;
    if (shouldConnect && this.ProfileInfo.web_rtc) this.loadSipml(true);
  },

  watch: {
    isConnectedToSIP(val) {
      this.loadSipml(val);
    },
    ProfileInfo() {
      if (this.isConnectedToSIP && this.ProfileInfo.web_rtc) this.loadSipml(true);
    },
    startCall(val) {
      if (!val) return;
      const call_number = this.$store.getters["dialer/GET_NUMBER_TO_CALLL"];

      this.sipCall({ call_number });
    },
  },

  beforeDestroy() {
    this.loadSipml(false);
  },

  methods: {
    async getQueues() {
      try {
        const { data } = await PbxHttpClient.get(`/clients/queues`);
        this.queueList = data.data;

        if (this.queueList.length > 0) this.payload.queue = data.data[0].number;

        // const salida = data.data.find((el) => el.name === "salida");
        this.payload = { ...this.payload, queue: data.data[0].number };
      } catch (err) {
        // console.log(err);
        this.$snotify.error("Hubo un error consultando las colas.", "¡Error!");
      }
      this.isLoadingQueues = false;
    },
    // elimina guiones y espacios al tipear o pegar
    formatCallNumber(value) {
      // Si se llama sin valor (v-model) tomamos el actual
      const val = typeof value === "string" ? value : this.payload.call_number || "";
      // eliminar guiones y espacios en blanco
      this.payload.call_number = val.replace(/[-\s]/g, "");
    },
    async submitForm(isVideo = false) {
      // asegurar que el número esté limpio antes de enviar
      this.payload.call_number = (this.payload.call_number || "").replace(/[-\s]/g, "");

      if (this.ProfileInfo.web_rtc && this.isConnectedToSIP) {
        this.isVideoCall = isVideo;
        this.sipCall(this.payload, isVideo ? "call-audiovideo" : undefined);
        this.toggleDialog();
        return;
      }

      this.isLoading = true;
      try {
        await PbxHttpClient.post(`/typing/call_now`, this.payload);
        this.$snotify.success("Llamada realizada con éxito.", "¡Hecho!");
        this.closeDialogAndSendTypification();
      } catch (error) {
        this.$snotify.error("Hubo un error realizando la llamada.", "¡Error!");
      }
      this.isLoading = false;
    },
    toggleDialog() {
      this.$refs.dialerForm.reset();
      this.$store.dispatch("dialer/TOGGLE_OPEN_DIALOG");
    },
    closeDialogAndSendTypification() {
      this.$emit("finished:call", { ...this.payload });
      this.toggleDialog();
    },

    async createTypificationRegistry() {
      console.log("creando....");
      try {
        await axios.post(
          `${process.env.VUE_APP_URL_BASE}:8096/api/temporary_table/create/front`,
          {
            extension: this.ProfileInfo.extension,
            ...this.dataFromCall,
            type: "S",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        // console.log("data from post t", data);
      } catch (error) {
        // console.log(error);
        this.$snotify.error("Hubo un error buscando la tipificacion.", "¡Error!");
      }
    },

    openNewPage() {
      if (this.ProfileInfo.client.url_new_page) window.open(this.ProfileInfo.client.url_new_page, "_blank");
    },

    async loadSipml(connect) {
      if (!connect) {
        if (!this.oSipStack) return;
        try {
          console.log("Cerrando stack SIP de forma definitiva...");
          await this.handleEndRtcSession();

          // 1. Desregistrar todas las sesiones del servidor
          this.oSipStack.unregister({ all: true });

          // 2. Quitar todos los listeners de eventos para que no reaccione a nada
          this.oSipStack.removeAllListeners();

          // 3. Parar el stack
          this.oSipStack.stop();

          // 4. Forzar el cierre del socket y desconectar eventos de red internos
          if (this.oSipStack.transport) {
            if (this.oSipStack.transport.socket) {
              this.oSipStack.transport.socket.disconnect();
            }
          }

          // 5. ¡CLAVE! Eliminar la instancia para que deje de existir en memoria
          this.oSipStack = null;

          localStorage.removeItem("sip");
          console.log("Stack SIP destruido.");
        } catch (err) {
          localStorage.setItem("sip", true);
        }
        return;
      }

      if (connect && this.oSipStack) {
        console.log("SIP Stack ya existe, no se crea uno nuevo.");
        return;
      }

      const user = this.ProfileInfo;

      console.log(`SIP: Connecting to ${this.ProfileInfo.client.web_socket_server_url}...`, "info");

      return await new Promise((res) => {
        JsSIP.debug.enable("JsSIP:*");

        const sipDomain = user.web_rtc?.public_identity.split("@")[1] || "tu-dominio.com";

        const socket = new JsSIP.WebSocketInterface(
          user.client.web_socket_server_url || "wss://combipollo.pbxberry.com:8089/ws",
        );
        // From v3
        const configuration = {
          sockets: [socket],
          uri: user.web_rtc?.public_identity || "",
          password: user.web_rtc?.Password || "",
          display_name: user.extension,
          authorization_user: user.extension, // Equivalente a 'impi'
          register: true, // Indica si debe registrarse automáticamente
          register_expires: 120, // Tiempo de re-registro en segundos
          contact_uri: `sip:${user.extension}@${sipDomain}`,
          hack_ip_in_contact: true,
          session_timers: false,
          hack_via_tcp: true,
          ice_servers: [{ urls: ["stun:stun.l.google.com:19302"] }],
          connection_recovery_min_interval: 2, // Reintento rápido si falla
          connection_recovery_max_interval: 30,
        };

        this.oSipStack = new JsSIP.UA(configuration);

        const audio_remote = document.getElementById("audio_remote");
        this.videoLocal = document.getElementById("video_local");
        this.videoRemote = document.getElementById("video_remote");
        this.oConfigCall = {
          audio_remote,
          video_local: document.getElementById("video_local"),
          video_remote: document.getElementById("video_remote"),
          screencast_window_id: 0x00000000, // entire desktop
          bandwidth: { audio: undefined, video: undefined },
          video_size: {
            minWidth: 300,
            minHeight: 300,
            maxWidth: undefined,
            maxHeight: undefined,
          },
          ice_servers: [],
          events_listener: { events: "*", listener: this.onSipEventSession },
          sip_caps: [{ name: "+g.oma.sip-im" }, { name: "language", value: '"en,fr"' }],
        };

        // 4. Configurar escuchadores de eventos (Equivalente a events_listener)
        this.oSipStack.on("connected", (e) => {
          console.log("### Conectado al WebSocket", e);
          localStorage.setItem("sip", true);
          res(true);
        });

        this.oSipStack.on("registered", () => {
          console.log("### Registrado en el PBX");
        });

        this.oSipStack.on("registrationFailed", (e) => {
          res(false);
          console.error("### Error de registro:", e.cause);
        });

        // this.oSipStack.on("newOptions", () => {
        //   console.log("Recibida petición OPTIONS del servidor (Keep-alive)");
        //   // JsSIP responde automáticamente 200 OK a los OPTIONS por defecto
        // });

        this.oSipStack.on("newRTCSession", (data) => {
          if (this.callSession) {
            try {
              this.callSession.terminate();
            } catch (e) {
              console.log("failed terminating the session", e);
            }
          }
          this.callButtons.mute = false;
          this.callButtons.hold = false;
          this.showKeypad = false;

          if (data.session.direction === "incoming") {
            const number = data.session.remote_identity.uri.user;
            const remoteName = data.session.remote_identity?.display_name || "";
            this.displayName = remoteName;
            this.callStatusText = `Llamada entrante: ${remoteName}`;
            console.log(`Inbound Call: ${number}`, "info");
            this.hasIncomingCall = true;
            this.incomingNumberCall = number;
            this.numberToCall = number;
            this.showCallBanner = true;
            startRingTone();
          }

          this.bindSessionEvents(data.session);
        });

        this.oSipStack.start();
      });
    },

    async handleEndRtcSession() {
      try {
        await PbxHttpClient.post(`/unrgwbrtc`, {
          ext: this.ProfileInfo.extension,
        });
      } catch (error) {
        console.log("error ending rtc session", error);
      }
    },

    handleRemoteStream(stream) {
      const remoteAudio = document.getElementById("audio_remote");
      if (remoteAudio) {
        remoteAudio.srcObject = stream;
        remoteAudio
          .play()
          .then(() => addLog("Audio: Playback started", "success"))
          .catch((e) => addLog(`Audio: Playback failed (${e.name})`, "error"));
      }
    },

    bindSessionEvents(session) {
      this.callSession = session;

      session.on("progress", (data) => {
        if (session.direction === "outgoing") {
          this.callStatusText = "Llamando";
          startRingbackTone();
          console.log(`SIP: Ringing (${data.response?.status_code || 180})`, "info");
        }
      });

      session.on("peerconnection", (data) => {
        addLog("SIP: PeerConnection created", "info");
        const pc = data.peerconnection;

        pc.addEventListener("iceconnectionstatechange", () => {
          addLog(`ICE Connection State: ${pc.iceConnectionState}`, "info");
        });

        pc.addEventListener("track", (event) => {
          if (event.track.kind === "audio") {
            addLog("Media: Track received", "success");
            const remoteStream = new MediaStream([event.track]);
            this.handleRemoteStream(remoteStream);
          }
        });
      });

      session.on("confirmed", () => {
        addLog("SIP: ACK (Confirmed)", "info");
        this.callStatusText = "Llamada en curso";
        stopRingbackTone(); // Asegurar parada de timbre

        if (session.connection) {
          const receivers = session.connection.getReceivers();
          const audioReceiver = receivers.find(
            (r) => r.track && r.track.kind === "audio" && r.track.readyState === "live",
          );
          if (audioReceiver) {
            const remoteStream = new MediaStream([audioReceiver.track]);
            this.handleRemoteStream(remoteStream);
          }
        }
      });

      // FIX SDP: Asterisk 18 Compatibility
      session.on("sdp", (data) => {
        if (data.originator !== "remote") return;

        const lines = data.sdp.split(/\r?\n/);
        const patchedLines = [];
        let sessionLevelParsed = false;

        for (let line of lines) {
          if (!line.trim()) continue;

          if (!sessionLevelParsed && line.startsWith("m=")) {
            if (!data.sdp.includes("a=msid-semantic:")) {
              patchedLines.push("a=msid-semantic: WMS *");
            }
            sessionLevelParsed = true;
          }

          if (line.startsWith("m=audio")) {
            if (!line.includes("UDP/TLS/RTP/SAVPF")) {
              line = line.replace(/RTP\/[A-Z]+/, "UDP/TLS/RTP/SAVPF");
            }
            patchedLines.push(line);

            if (!data.sdp.includes("a=mid:")) {
              patchedLines.push("a=mid:0");
            }
            if (!data.sdp.includes("a=msid:")) {
              patchedLines.push("a=msid:default-audio-stream default-audio-track");
            }
            continue;
          }
          patchedLines.push(line);
        }

        data.sdp = patchedLines.join("\r\n") + "\r\n";
        addLog("SIP: Remote SDP Patched", "info");
      });

      session.on("accepted", () => {
        this.callStatusText = `Llamada en curso`;
        stopRingbackTone(); // Detener timbre
        addLog("Call: Answered", "success");
        this.callStatusText = "Llamada en curso";
        this.showCallCounter = true;
        this.counterStatus = "play";
        stopRingbackTone();
        stopRingTone();
      });

      session.on("hold", () => {
        this.callButtons.hold = true;
        this.callStatusText = "Llamada en pausa";
      });
      session.on("unhold", () => {
        this.callButtons.hold = false;
        this.callStatusText = "Llamada en curso";
      });

      session.on("mute", (data) => {
        console.log("mute data", data);
        this.callButtons.mute = true;
      });
      session.on("unmute", (data) => {
        console.log("unmute data", data);
        this.callButtons.mute = false;
      });

      session.on("refer", (data) => {
        console.log("refer data", data);
        addLog("SIP: Transfer request accepted by server", "success");
      });

      session.on("ended", () => {
        this.callStatusText = "";
        this.callButtons = {
          mute: false,
          hold: false,
        };
        addLog("Call: Terminated", "info");
        this.showCallBanner = false;
        this.showCallCounter = false;
        this.callStatusText = "Llamando";
        this.counterStatus = "pause";

        stopRingbackTone(); // Detener timbre
        stopRingTone();
        const remoteAudio = document.getElementById("audio_remote");
        if (remoteAudio) {
          remoteAudio.pause();
          remoteAudio.srcObject = null;
        }
        this.callSession = null;
      });

      session.on("failed", (data) => {
        this.callStatusText = "";
        this.callButtons = {
          mute: false,
          hold: false,
        };
        this.showCallBanner = false;
        this.showCallCounter = false;
        this.callStatusText = "Llamando";
        this.counterStatus = "pause";
        stopRingTone(); // Detener timbre
        addLog(`Call: Failed (${data.cause})`, "error");
        this.callSession = null;
      });
    },

    async refreshDevices() {
      try {
        const devs = await navigator.mediaDevices.enumerateDevices();
        const audioInputs = devs.filter((d) => d.kind === "audioinput");
        this.audioDevices = audioInputs;
        if (audioInputs.length > 0 && !this.selectedAudioInput) {
          this.selectedAudioInput = audioInputs[0].deviceId;
        }
      } catch (e) {
        addLog("Error accessing media devices", "error");
      }
    },
    getMediaConstraints() {
      const audioConfig = this.selectedAudioInput ? { deviceId: this.selectedAudioInput } : true;

      return {
        audio: {
          ...(typeof audioConfig === "object" ? audioConfig : {}),
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
        video: false,
      };
    },
    handleAnswerSipCal() {
      if (!this.callSession) return;
      this.callSession.answer({
        mediaConstraints: this.getMediaConstraints(),
      });
    },
    handleDeclineSipCall() {
      if (!this.callSession) return;
      this.callSession.terminate();
    },
    async sipCall(payload, s_type = "call-audio") {
      console.log("s_type", s_type);
      const callNumber = payload.call_number;
      this.dataFromCall = { ...payload };

      addLog(`Dialing: ${payload.call_number}...`, "info");

      const options = {
        mediaConstraints: this.getMediaConstraints(),
        pcConfig: {
          iceServers: [],
          rtcpMuxPolicy: "require",
          bundlePolicy: "balanced",
        },
        rtcOfferConstraints: { offerToReceiveAudio: true, offerToReceiveVideo: false },
      };
      try {
        this.oSipStack.call(payload.call_number, options);
        this.callStatusText = "Llamando";
        this.numberToCall = payload.call_number;
        this.showCallBanner = true;

        if (!this.startCall && !this.IsFromCampaignRegister) {
          await this.createTypificationRegistry();
          if (callNumber) {
            this.$emit("finished:call", { call_number: callNumber || this.incomingNumberCall });
          } else {
            this.$emit("finished:call", { call_number: callNumber || this.incomingNumberCall });
          }
        }
      } catch (e) {
        addLog(`Dialing error: ${e.message}`, "error");
      }
    },
    onSipEventSession(e /* SIPml.Session.Event */) {
      console.log("==session event = " + e.type);
      switch (e.type) {
        case "connecting":
        case "connected":
          // eslint-disable-next-line no-case-declarations
          const bConnected = e.type == "connected";
          // eslint-disable-next-line no-empty
          if (e.session == this.oSipSessionRegister) {
          } else if (e.session == this.oSipSessionCall) {
            this.showCallBanner = true;
            if (bConnected) {
              this.callStatusText = "Llamada en curso";
              this.showCallCounter = true;
              this.counterStatus = "play";
              stopRingbackTone();
              stopRingTone();

              // if (oNotifICall) {
              //   oNotifICall.cancel();
              //   oNotifICall = null;
              // }
            }
            // if (SIPml.isWebRtc4AllSupported()) {
            this.uiVideoDisplayEvent(false, true);
            this.uiVideoDisplayEvent(true, true);
            // }
          }
          break;
        case "terminating":
        case "terminated":
          if (e.session == this.oSipSessionRegister) {
            this.oSipSessionCall = null;
            this.oSipSessionRegister = null;
            this.isVideoCall = false;
            // console.log(
            //   "event terminated description: equal session",
            //   e.description
            // );
          } else if (e.session == this.oSipSessionCall) {
            this.isVideoCall = false;
            // console.log("event terminated description:", e.description);
            if (e.description === "Busy Here") this.$snotify.warning("Llamada rechazada");
          }
          if (e.type === "terminated") this.oSipSessionCall = null;
          this.showCallBanner = false;
          this.showCallCounter = false;
          this.callStatusText = "Llamando";
          this.counterStatus = "pause";

          stopRingbackTone();
          stopRingTone();
          break;
        case "m_stream_audio_local_added":
        case "m_stream_audio_local_removed":
        case "m_stream_audio_remote_added":
        case "m_stream_audio_remote_removed": {
          break;
        }
        case "m_stream_video_local_added": {
          if (e.session == this.oSipSessionCall) {
            this.uiVideoDisplayEvent(true, true);
          }
          break;
        }
        case "m_stream_video_local_removed": {
          if (e.session == this.oSipSessionCall) {
            this.uiVideoDisplayEvent(true, false);
          }
          break;
        }
        case "m_stream_video_remote_added": {
          if (e.session == this.oSipSessionCall) {
            this.isVideoCall = true;
            this.uiVideoDisplayEvent(false, true);
          }
          break;
        }
        case "m_stream_video_remote_removed": {
          if (e.session == this.oSipSessionCall) {
            this.uiVideoDisplayEvent(false, false);
          }
          break;
        }

        case "m_local_hold_ok": {
          if (e.session == this.oSipSessionCall) {
            if (this.oSipSessionCall.bTransfering) this.oSipSessionCall.bTransfering = false;
            this.oSipSessionCall.bHeld = true;
            this.callStatusText = "Llamada en pausa";
          }
          break;
        }
        case "m_local_hold_nok": {
          if (e.session == this.oSipSessionCall) {
            this.oSipSessionCall.bTransfering = false;
          }
          break;
        }
        case "m_local_resume_ok":
          if (e.session == this.oSipSessionCall) {
            this.oSipSessionCall.bTransfering = false;
            this.oSipSessionCall.bHeld = false;
            this.callStatusText = "Llamada en curso";
          }
          break;
        case "m_local_resume_nok":
          if (e.session == this.oSipSessionCall) this.oSipSessionCall.bTransfering = false;

          break;
        case "i_ao_request":
          if (e.session == this.oSipSessionCall) {
            var iSipResponseCode = e.getSipResponseCode();
            if (iSipResponseCode == 180 || iSipResponseCode == 183) {
              startRingbackTone();
            }
          }
          break;
        case "i_ect_new_call":
          this.oSipSessionTransferCall = e.session;
          break;
        case "m_remote_hold":
          if (e.session == this.oSipSessionCall) this.callStatusText = "Placed on hold by remote party";

          break;

        case "m_remote_resume":
          if (e.session == this.oSipSessionCall) this.callStatusText = "Taken off hold by remote party";

          break;

        case "o_ect_trying":
          if (e.session == this.oSipSessionCall) this.callStatusText = "Transfiriendo Llamada";

          break;

        case "o_ect_accepted":
          if (e.session == this.oSipSessionCall) this.callStatusText = "Transferencia aceptada";
          this.$snotify.success("Transferencia aceptada");
          break;

        case "o_ect_completed":
        case "i_ect_completed":
          if (e.session == this.oSipSessionCall) {
            this.callStatusText = "Transferencia completada";
            // eslint-disable-next-line no-undef
            if (oSipSessionTransferCall) this.oSipSessionCall = oSipSessionTransferCall;
            this.$snotify.success("Transferencia de llamada completada", "¡Hecho!");

            this.oSipSessionTransferCall = null;
          }
          break;

        case "o_ect_failed":
        case "i_ect_failed":
          if (e.session == this.oSipSessionCall)
            // console.log("Call transfer failed");

            break;
          break;

        case "o_ect_notify":
        case "i_ect_notify":
          if (e.session == this.oSipSessionCall) {
            this.callStatusText = "Tranferencia de llamada: " + e.getSipResponseCode() + " " + e.description;
            if (e.getSipResponseCode() >= 300) {
              if (this.oSipSessionCall.bHeld) {
                this.oSipSessionCall.resume();
              }
            }
          }
          break;
        case "i_ect_requested":
          if (e.session == this.oSipSessionCall) {
            const s_message = "Do you accept call transfer to [" + e.getTransferDestinationFriendlyName() + "]?"; //FIXME
            if (confirm(s_message)) {
              this.oSipSessionCall.acceptTransfer();
              break;
            }
            this.oSipSessionCall.rejectTransfer();
          }
          break;
      }
    },
    sipHangUp() {
      stopRingTone(); // Seguridad
      stopRingbackTone(); // Seguridad
      if (this.oSipStack) {
        try {
          this.callSession.terminate();
        } catch (e) {
          console.warn("Termination warning:", e);
          this.callSession = null;
        }
        this.$store.dispatch("dialer/CHANGE_CALL_STATUS", false);
        if (this.startCall) this.$store.dispatch("dialer/STOP_DIRECT_CALL");
      }
    },
    sipToggleMute() {
      if (!this.callSession) return;
      const currentMuted = this.callSession.isMuted().audio;
      const nextMuted = !currentMuted;
      this.callButtons.mute = nextMuted;
      addLog(`User Action: ${nextMuted ? "Muted" : "Unmuted"}`, "info");
      const options = { audio: true, video: false };
      if (currentMuted) this.callSession.unmute(options);
      else this.callSession.mute(options);
      // if (this.oSipSessionCall) {
      //   let i_ret;
      //   const bMute = !this.oSipSessionCall.bMute;

      //   i_ret = this.oSipSessionCall.mute("audio" /*could be 'video'*/, bMute);
      //   if (i_ret != 0) {
      //     // eslint-disable-next-line no-undef
      //     txtCallStatus.innerHTML = "<i>Mute / Unmute failed</i>";
      //     return;
      //   }
      //   this.callButtons.mute = bMute;
      //   this.oSipSessionCall.bMute = bMute;
      // }
    },
    sipToggleHoldResume() {
      if (!this.callSession) return;
      console.log(" ### ", this.callSession);
      const isHeld = this.callButtons.hold;
      if (isHeld) {
        this.callSession.unhold();
      } else {
        this.callSession.hold();
      }
      this.counterStatus = isHeld ? "play" : "pause";
      // if (this.oSipSessionCall) {
      //   // eslint-disable-next-line no-unused-vars
      //   const i_ret = this.oSipSessionCall.bHeld ? this.oSipSessionCall.resume() : this.oSipSessionCall.hold();

      //   this.counterStatus = this.oSipSessionCall.bHeld ? "play" : "pause";
      // }
    },
    sipTransfer() {
      if (this.callSession) {
        var s_destination = prompt("Enter destination number", "");
        if (s_destination.length) {
          try {
            this.callSession.refer(s_destination);
            addLog("Refer sent. Waiting for server...", "info");
          } catch (e) {
            addLog(`Transfer Error: ${e.message}`, "error");
          }
          // if (this.oSipSessionCall.transfer(s_destination) != 0) return;

          this.callStatusText = "Transfiriendo Llamada";
        }
      }
    },

    async showNotifICall(incomingNumber) {
      if (await checkNotificationPermission()) {
        this.oNotifICall?.cancel();

        this.oNotifICall = new Notification("Llamada entrante", {
          body: `Llamada entrante de ${incomingNumber}`,
        });
        this.oNotifICall.onclose = function() {
          this.oNotifICall = null;
        };
        this.oNotifICall.show();
      }
    },
    sipSendDTMF(value) {
      if (this.callStatusText === "Llamada en curso" && this.callSession) {
        this.callSession.sendDTMF(value);
        addLog(`DTMF Sent: ${value}`, "info");
      }
      // else {
      // Si no, lo agregamos al input de destino
      // setDestination(prev => prev + tone);
      // }
      // const c = value.split("").pop();
      // console.log("c", c);
      // const dtmfTone = document.getElementById("dtmfTone");
      // if (this.oSipSessionCall && c)
      //   if (this.oSipSessionCall.dtmf(c) == 0) {
      //     try {
      //       dtmfTone.play();
      //     } catch (e) {
      //       console.log("error sending DTMF", e);
      //     }
      //   } else {
      //     console.log("not working");
      //   }
    },
    uiVideoDisplayEvent(b_local, b_added) {
      const videoLocal = document.getElementById("video_local");
      const videoRemote = document.getElementById("video_remote");
      const o_elt_video = b_local ? videoLocal : videoRemote;

      if (b_added) {
        o_elt_video.style.opacity = 1;
      } else {
        o_elt_video.style.opacity = 0;
      }
    },
  },
};
</script>

<style></style>
